
import { useEffect, useState } from "react";
import { Search, ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from "@/components/ui/sidebar";

export function AppSidebar() {
  const [categories, setCategories] = useState<{ id: number; name: string; sequence: number }[]>([]);

  useEffect(() => {
    fetch("https://moncopieur.cloud-erp.ma/ws/product_category")
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          data.sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));
          setCategories(data);
        } else {
          setCategories([]);
        }
      })
      .catch(() => {
        setCategories([]);
      });
  }, []);

  return (
    <Sidebar>
      <SidebarContent>
        {/* Search Section */}
        <SidebarGroup>
          <SidebarGroupLabel>Recherche</SidebarGroupLabel>
          <SidebarGroupContent>
            <div className="relative px-2">
              <Search className="absolute left-5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder="Rechercher des produits..."
                className="pl-10 bg-background"
                aria-label="Recherche"
              />
            </div>
          </SidebarGroupContent>
        </SidebarGroup>

        {/* Categories Section */}
        <SidebarGroup>
          <SidebarGroupLabel>Catégories</SidebarGroupLabel>
          <SidebarGroupContent>
            <div>
              {categories.map((category, index) => (
                <div
                  key={category.id}
                  className={`relative ${index === 0 ? 'border-t' : ''} border-b border-border`}
                >
                  <Link
                    to={`/produits?categorie=${encodeURIComponent(category.name)}`}
                    className="flex items-center justify-between w-full py-3 text-left text-sm font-medium text-foreground hover:bg-accent hover:text-accent-foreground"
                  >
                    <span>{category.name}</span>
                    <ChevronRight className="h-4 w-4" />
                  </Link>
                </div>
              ))}
            </div>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
